import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { ServiceCatalogItem } from "../../../store/ServiceCatalog/types";

export interface BrowserRow {
	badge: string;
	badgeClass: string;
	code: string;
	description: string;
	catalogItem: ServiceCatalogItem;
}

interface ServiceCatalogBrowserDraggableItemProps {
	id: string;
	row: BrowserRow;
}

export const ServiceCatalogBrowserDraggableItem: React.FC<
	ServiceCatalogBrowserDraggableItemProps
> = ({ id, row }) => {
	const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
		id,
		data: {
			type: "browser-item",
			catalogItem: row.catalogItem,
			badge: row.badge,
			code: row.code,
			description: row.description,
		},
	});

	return (
		<div
			ref={setNodeRef}
			{...attributes}
			{...listeners}
			className="flex items-center gap-2 py-1.5 px-2 rounded hover:bg-muted/50 cursor-grab transition-colors"
			style={{ opacity: isDragging ? 0.5 : 1 }}
			data-testid={`browser-item-${row.badge}-${row.code}`}
		>
			<span
				className={`text-xs rounded px-1.5 py-0.5 font-mono font-semibold shrink-0 ${row.badgeClass}`}
			>
				{row.badge}
			</span>
			<span className="text-xs font-mono text-muted-foreground shrink-0">
				{row.code}
			</span>
			<span
				className="text-sm truncate flex-1 min-w-0"
				title={row.description}
			>
				{row.description}
			</span>
		</div>
	);
};
